// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
// console.log('Vite ⚡️ Rails')

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

// console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails')

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'


import "@hotwired/turbo-rails"
import "~/controllers/public"
import * as bootstrap from "bootstrap"

Turbo.StreamActions.update_with_selector = function () {
  const selector = this.getAttribute("target")
  const newContent = this.templateContent.firstElementChild
  const targets = document.querySelectorAll(selector)
  targets.forEach(el => el.replaceWith(newContent.cloneNode(true)))
}

/* flash animation */
document.addEventListener("turbo:load", () => {
  document.querySelectorAll(".alert.animate__bounceInDown").forEach((alert) => {
    setTimeout(() => {
      alert.classList.remove("animate__bounceInDown");
      alert.classList.add("animate__bounceOutUp");

      // Remove the element from the DOM after animation
      alert.addEventListener("animationend", () => {
        alert.remove();
      });
    }, 15000); // 15 seconds delay before fadeOut starts
  });
});
